// Claude: departmentsAPI.js — admin-managed department list CRUD 16-Apr-2026
import { api } from "./config/axiosConfig.js";
import { store } from "../redux/Store.ts";
import { errorResponseHandler, responseHandler } from "../Utils/handler.ts";

const getToken = () => store.getState().user?.token;

export const DepartmentsAPI = {

  // Public — buyers, sellers, admin all need to fetch the list
  getAll: async () => {
    try {
      const response = await api.request({
        url: "/departments",
        method: "GET",
        headers: { Authorization: `Bearer ${getToken()}` },
      });
      return responseHandler(response);
    } catch (err) {
      throw errorResponseHandler(err);
    }
  },

  create: async (data) => {
    try {
      const response = await api.request({
        url: "/departments",
        method: "POST",
        data,
        headers: { Authorization: `Bearer ${getToken()}` },
      });
      return responseHandler(response);
    } catch (err) {
      throw errorResponseHandler(err);
    }
  },

  update: async (id, data) => {
    try {
      const response = await api.request({
        url: `/departments/${id}`,
        method: "PUT",
        data,
        headers: { Authorization: `Bearer ${getToken()}` },
      });
      return responseHandler(response);
    } catch (err) {
      throw errorResponseHandler(err);
    }
  },

  remove: async (id) => {
    try {
      const response = await api.request({
        url: `/departments/${id}`,
        method: "DELETE",
        headers: { Authorization: `Bearer ${getToken()}` },
      });
      return responseHandler(response);
    } catch (err) {
      throw errorResponseHandler(err);
    }
  },

};
